module.exports = __webpack_public_path__ + "static/img/cancel_appointment.8616282.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cancel_appointment.jpg
// module id = 9nyJ
// module chunks = 7